export const BULK_UPLOAD = 'BULK_UPLOAD';
export const UPLOAD_GROUND_TRUTHS = 'UPLOAD_GROUND_TRUTHS';
export const ANALYZE = 'ANALYZE';
export const GENERATE_API_KEY = 'GENERATE_API_KEY';

export default [
  {
    key: BULK_UPLOAD,
    title: 'Bulk upload test documents',
    description:
      'Collect and ZIP 1,000-2,000 historical documents used to verify customers and we will upload each to a customer folder. We accept .pdf, .jpeg and .png file types',
  },
  {
    key: UPLOAD_GROUND_TRUTHS,
    title: 'Upload ground truths to see how we did',
    description:
      'Once your upload is finished uploading, download our ground truth template and record which documents you knew to be fraudulent, and what names/addresses you expected to be in each. This will help you assess our performance.',
    routeName: 'ground-truth-upload',
  },
  {
    key: ANALYZE,
    title: 'Analyze the results',
    description:
      'Use our analytics dashboard to see how many fraudulent documents we detected, which types of documents they were, and most importantly, how we performed compared to the ground truths',
    button: 'Analyze',
    routeName: 'pilot-dashboard-view',
  },
  {
    key: GENERATE_API_KEY,
    title: 'Integrate with our API',
    description:
      'Generate an API key and get started using our API, to upload and assess documents much faster, fitting into your existing fraud dassess documents much faster, fitting into your existing fraud',
    button: 'Get started',
    routeName: 'api-settings-list-keys',
  },
];
